import SpriteSymbol from "svg-baker-runtime/browser-symbol";
import sprite from "svg-sprite-loader/runtime/browser-sprite.build";
var symbol = new SpriteSymbol({
  "id": "icon-si-glyph-helmet",
  "use": "icon-si-glyph-helmet-usage",
  "viewBox": "0 0 17 16",
  "content": "<symbol viewBox=\"0 0 17 16\" xmlns=\"http://www.w3.org/2000/svg\" xmlns:xlink=\"http://www.w3.org/1999/xlink\" class=\"si-glyph si-glyph-helmet\" id=\"icon-si-glyph-helmet\">\n    <!-- Generator: Sketch 3.0.3 (7891) - http://www.bohemiancoding.com/sketch -->\n    <title>952</title>\n    \n    <defs></defs>\n    <g stroke=\"none\" stroke-width=\"1\" fill=\"none\" fill-rule=\"evenodd\">\n        <path d=\"M15.706,8.697 L15.582,8.697 C15.238,4.943 12.125,2.004 8.329,2.004 C4.303,2.004 1.041,5.309 1.041,9.387 C1.041,11.966 2.233,13.976 6.259,13.976 C9.405,13.976 8.239,11.173 11.574,9.95 L15.706,9.95 C16.408,9.95 16.978,9.679 16.978,9.349 L16.978,9.298 C16.979,8.967 16.408,8.697 15.706,8.697 L15.706,8.697 Z M6.062,11.042 L4.937,11.042 L4.937,9.958 L6.062,9.958 L6.062,11.042 L6.062,11.042 Z\" fill=\"#434343\" class=\"si-glyph-fill\" />\n    </g>\n</symbol>"
});
var result = sprite.add(symbol);
export default symbol


//////////////////
// WEBPACK FOOTER
// ./src/icons/svg/glyph/si-glyph-helmet.svg
// module id = ieNy
// module chunks = 62